import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import auth from "../components/helper/auth"

Vue.use(VueRouter)

const routes = [
    // {
    //     path: "/",
    //     name: "Home",
    //     component: Home
    // },
    // {
    //     path: "/logout",
    //     beforeEnter(to, from, next) {
    //         auth.logout()
    //         next("/login")
    //     }
    // },
    // {
    //     path: "/login",
    //     name: "Login",
    //     component: () => import(/* webpackChunkName: "about" */ "../views/Login.vue")
    // },
    // {
    //     path: "/register",
    //     name: "Register",
    //     component: () => import(/* webpackChunkName: "about" */ "../views/Register.vue")
    // },
    {
        path: "/turnover",
        name: "Umsaetze",
        component: () => import(/* webpackChunkName: "about" */ "../views/Umsaetze.vue")
        // beforeEnter: requireAuth,
    }
    // {
    //   path: '/monitoring',
    //   name: 'Monitoring',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/Monitoring.vue') ,
    //   // beforeEnter: requireAuth,
    // },
    // {
    //   path: '/allresearches',
    //   name: 'AllResearches',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AllResearches.vue') ,
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/research/:researchname',
    //   name: 'Research',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/Research.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/myresearches',
    //   name: 'MyResearches',
    //   component: () => import(/* webpackChunkName: "about" */ '../views/MyResearches.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/keywordplanner',
    //   name: 'KeywordPlanner',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/KeywordPlanner.vue'),
    //   beforeEnter: requireAuth,
    // },
    // {
    //   path: '/suggests',
    //   name: 'Suggests',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/Suggests.vue'),
    //   beforeEnter: requireAuth,
    // }
]

function requireAuth(to, from, next) {
    next()
    auth.loggedIn().then((response) => {
        if (!response) {
            console.log()
            next({
                path: "/login",
                query: { redirect: to.fullPath }
            })
        }
    })
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
})

export default router
